import cn from '../../lib/cn';

/** Page-width wrapper. `wide` opts into the full 1280px container. */
export default function Container({ children, className, wide = false }) {
  return (
    <div className={cn('container', !wide && 'max-w-6xl', className)}>{children}</div>
  );
}
